import "./modalVideo.css";

const ModalVideo = ({ isOpen, closeModal, urlVideo }) => {
  if (!isOpen) return null;
  return (
    <div className="modal">
      <div className="modalContent">
        {/* <div
          className="div_otro"
          dangerouslySetInnerHTML={{ __html: urlVideo }}
        /> */}
        <div className="div_otro">
          <iframe
            // width="840"
            // height="630"
            className="iframeVideo"
            src={urlVideo}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <button
          className="botonPop"
          onClick={() => {
            closeModal();
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="background_gri"></div>
    </div>
  );
};
export default ModalVideo;